<template>
  <el-dialog :title="title" :visible.sync="visible" width="1200px"  top="5vh" append-to-body :close-on-click-modal="false">
    <el-form :model="queryParams" ref="queryForm" :inline="true">
      <el-form-item prop="productName">
        <el-input
          v-model="queryParams.productName"
          placeholder="请输入套餐名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item prop="productType">
        <el-select v-model="queryParams.productType" filterable clearable placeholder="请输入套餐类型">
          <el-option v-for="item in productTypes" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" @click="submitInternationalProduct">确定提交</el-button>
      </el-form-item>
    </el-form>
    <el-table  border ref="table" :data="productData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column label="套餐ID" prop="id" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="套餐名称" prop="productName" min-width="160"  align="center" :show-overflow-tooltip="true" />
      <el-table-column label="套餐总量/M" prop="flowCount"  align="center" min-width="120" :show-overflow-tooltip="true" />
      <el-table-column label="套餐有效期/天" prop="validityTime" min-width="120" align="center"  :show-overflow-tooltip="true" />
      <el-table-column label="套餐类型" align="center" prop="status">
        <template slot-scope="scope">
          <el-tag>{{transferProductType(scope.row.productType)}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />
  </el-dialog>
</template>

<script>
//套餐列表
import { saveCustomInternationalProducts , agentDetail , basicProductPage , listChannel } from "@/api/api.js"; //分页套餐列表
export default {
  props: {
    // 代理商userId
    userId: {
      type: [Number, String]
    }
  },
  data() {
    return {
      // 遮罩层
      visible: false,
      // 总条数
      total: 0,
      // 套餐列表
      productData: [],
      pageNum: 1,
      pageSize: 10,
      title:"选择国际套餐",
      // 查询参数
      queryParams: {
        userId: undefined,
        productName: undefined,
        productType: undefined,
        channel:undefined,
        type:'3'
      },
      channels:[],
      productTypes:[
        {"value":"累计套餐","key":1},
        {"value":"月套餐","key":2},
        {"value":"加油包","key":3}
      ],
      //选中的套餐
      customProducts:[]
    };
  },
  created(){
    this.selectAgentDetail()
  },
  methods: {
    // 显示弹框
    show() {
      this.getList();
      this.visible = true;
    },
    // 获取数据
    selectAgentDetail(){
      agentDetail({userId : this.userId}).then(res=>{
        let username = res.data.data.agent.username;
        let company = res.data.data.agent.companyName;
        this.title = "选择国际套餐-"+"[" + username + "]" + company;
      });
    },
    transferProductType(status) {
      let obj = {
        1: "累计套餐",
        2: "月套餐",
        3: "加油包套餐",
        4: "停机保号套餐",
        5: "补卡套餐",
        6: "加速包套餐",
        7: "测试套餐",
        8: "赠送套餐",
        9: "发票套餐",
        10: "流量池加油包"
      };
      return obj[status];
    },
    // 查询表数据
    getList() {
      let params = {
        model : {
          ... this.queryParams,
          status:"1"
        },
        page : this.pageNum,
        pageSize : this.pageSize
      }
      basicProductPage(params).then(res => {
        this.productData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    //保存选中的套餐
    submitInternationalProduct(){
      if(this.customProducts.length <= 0){
        this.$modal.msgError("请选择套餐");
        return;
      }
      saveCustomInternationalProducts({ userId: this.userId, customProducts: this.customProducts }).then(res=>{
        this.visible = false;
        //父组件传值
        this.$emit("ok");
      })
    },
    handleSelectionChange(selection) {
      this.customProducts = selection.map(item => {
        let param = {
          productId : item.id,
          customPrice : item.customPrice
        }
        return param;
      });
    },
  }
};
</script>
